var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 120,
    viewBox: "0 0 72 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Bottle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bottle",
    clipPath: "url(#clip-Bottle)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(-697.984 -457.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M769.631,543.558c-1.046-6.888-4.05-13.264-7.016-19.516l-21.708-45.775c-2.819-5.944-6.453-12.567-12.709-13.866-4.389-.911-8.887,1.147-13.346.755-2.011-.174-2.7-3.5-3.609-6.721a15.908,15.908,0,0,1-10.874,4.288c1.8,3.2,5.4,6.231,4.886,10.243-.3,2.371-2.256,4.07-3.693,5.944-3.231,4.223-4.047,10.01-3.343,15.351s2.773,10.373,4.823,15.329c4.984,12.051,9.712,24.222,15.077,36.1,3.316,7.342,5.561,15.475,10.408,21.974,6.159,8.257,13.087,5.406,21.9,3.09,5.323-1.4,10.765-3.413,14.5-7.6C769.481,558.045,770.677,550.442,769.631,543.558Z",
    transform: "translate(0 3.865)",
    fill: "#cee5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M705.647,470.968a21.145,21.145,0,0,0,6.533-3.271,4.449,4.449,0,0,0,2.077-2.855,4.926,4.926,0,0,0-.831-2.749q-.793-1.479-1.582-2.957a4.3,4.3,0,0,0-1.4-1.76,3.932,3.932,0,0,0-3.24.053,41.911,41.911,0,0,0-7.289,3.512c-1.1.634-2.062,1.318-1.915,2.787a5.224,5.224,0,0,0,.457,1.488C699.895,468.641,701.206,472.293,705.647,470.968Z",
    transform: "translate(0 0)",
    fill: "#65a8df"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/Bottle.5336ebf2dd8ca75a2448406d052058fc.svg";
export { ForwardRef as ReactComponent };